// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import webConfig from './webconfig.config'
import VueClipboard from 'vue-clipboard2'
import { Tag,Search,Tabbar, NavBar, TabbarItem, Tab, Tabs, Button,Icon, Swipe, SwipeItem, Lazyload, CountDown, Popup, Stepper, Checkbox, CheckboxGroup, RadioGroup, Radio, Cell, CellGroup, Image as VanImage, Col, Row, Field, Divider, Switch,Toast,PullRefresh,List,Form,Dialog,Empty  } from 'vant';
Vue.use(Tag).use(Button).use(Icon).use(Swipe).use(SwipeItem).use(Lazyload, {
  lazyComponent: true,
}).use(CountDown).use(Tabbar).use(TabbarItem).use(NavBar).use(Tab).use(Tabs).use(Popup).use(Stepper).use(Checkbox).use(CheckboxGroup).use(Radio).use(RadioGroup).use(Cell).use(CellGroup).use(VanImage).use(Col).use(Row).use(Field).use(Divider).use(Switch).use(Toast)
.use(PullRefresh).use(List).use(Form).use(Dialog).use(VueClipboard).use(Search).use(Empty);


import "./assets/css/api.css";
import "./assets/css/style.css";

Vue.config.productionTip = false
Vue.prototype.$webConfig=webConfig;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js